exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline-labels label[data-v-4f54a3d6] {\n  margin-right: 10px;\n  margin-bottom: 0;\n}\n.field-to-update[data-v-4f54a3d6] {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  background: #f5f5f5;\n  font-size: 12px;\n}\n", ""]);

// exports
